import script from "./ErrorMessage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ErrorMessage.vue?vue&type=script&lang=ts&setup=true"

import "./ErrorMessage.vue?vue&type=style&index=0&id=dae70978&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/jobs/MYNAVI_MP_VIEW_G_PROD/workspace/view/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dae70978"]])

export default __exports__